module.exports = __webpack_public_path__ + "static/media/wide.90ab94d7.jpg";